import axios from "axios";
import { store } from "../reduxSlices/store";
import { triggerToast } from "../reduxSlices/slices/toastSlice";

// const API_BASE_URL = "https://vastuauraaligners.com";
const API_BASE_URL = process.env.REACT_APP_BASE_URL

const axios_instance = axios.create({
    baseURL: API_BASE_URL,
    timeout: 10000,
});

// ✅ Attach Access Token to Requests
axios_instance.interceptors.request.use(
    (config) => {
        const accessToken = localStorage.getItem("accessToken");
        console.log("🔹 Sending Request to:", config.url);
        if (accessToken) {
            console.log("🔹 Attaching Access Token:", accessToken);
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        console.error("❌ Request setup failed:", error);
        return Promise.reject(error);
    }
);

// ✅ Handle Token Expiry & Refresh
axios_instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            console.warn("⚠️ 401 Unauthorized - Attempting token refresh...");
            originalRequest._retry = true;

            const refreshToken = localStorage.getItem("refreshToken");

            if (!refreshToken) {
                console.warn("⚠️ No refresh token found. Redirecting to login.");
                localStorage.clear();
                window.location.href = "/login";
                return Promise.reject(error);
            }

            try {
                console.log("🔄 Calling refresh API...");
                const { data } = await axios.post(
                    `${API_BASE_URL}/account/token/refresh/`,
                    { refresh: refreshToken }
                );

                console.log("✅ Token refreshed successfully:", data.access);
                localStorage.setItem("accessToken", data.access);
                localStorage.setItem("refreshToken", data.refresh);

                // ✅ Retry the original request with the new token
                originalRequest.headers["Authorization"] = `Bearer ${data.access}`;
                return axios_instance(originalRequest);
            } catch (refreshError) {
                console.error("❌ Token refresh failed:", refreshError);
                store.dispatch(
                    triggerToast({
                        type: "error",
                        message: "Session expired. Please log in again.",
                    })
                );

                localStorage.clear();
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axios_instance;
